import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { typographyTemplate, outlineTemplate } from '@equinor/eds-utils';
import { link, quickVariants, typography, colors } from './Typography.tokens.js';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["variant", "children", "bold", "italic", "link", "lines", "color", "group", "token", "as"];
var getElementType = function getElementType(variant, link) {
  if (link) {
    return 'a';
  }
  switch (variant) {
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
    case 'h6':
      return variant;
    case 'caption':
    case 'overline':
    case 'ingress':
    case 'meta':
    case 'body_short':
    case 'body_long':
    default:
      return 'p';
  }
};
var findTypography = function findTypography(variantName, group) {
  // For quick use when using paragraphs and headings we can skip group
  if (!group && quickVariants[variantName]) {
    return quickVariants[variantName];
  }
  return typography[group][variantName];
};

//@TODO: fix typescript here
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
var findColor = function findColor() {
  var inputColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return typeof colors[inputColor] === 'undefined' ? inputColor : colors[inputColor];
};
var toVariantName = function toVariantName(variant) {
  var bold = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var italic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var link = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return "".concat(variant).concat(bold ? '_bold' : '').concat(italic ? '_italic' : '').concat(link ? '_link' : '');
};
var StyledTypography = styled.p.withConfig({
  displayName: "Typography__StyledTypography",
  componentId: "sc-179guof-0"
})(["", " ", " ", " ", ""], function (_ref) {
  var $typography = _ref.$typography,
    $link = _ref.$link;
  return typographyTemplate($typography, $link);
}, function (_ref2) {
  var $color = _ref2.$color;
  return css({
    color: findColor($color)
  });
}, function (_ref3) {
  var $lines = _ref3.$lines;
  return (
    //https://caniuse.com/#feat=css-line-clamp
    $lines > 0 && css(["&{display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;}"], $lines)
  );
}, function (_ref4) {
  var $link = _ref4.$link;
  return $link && css(["&:focus{outline:none;}&[data-focus-visible-added]:focus{", "}&:focus-visible{", "}"], outlineTemplate(link.states.focus.outline), outlineTemplate(link.states.focus.outline));
});
var Typography = /*#__PURE__*/forwardRef(function Typography(_ref5, ref) {
  var _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? 'body_short' : _ref5$variant,
    children = _ref5.children,
    bold = _ref5.bold,
    italic = _ref5.italic,
    link = _ref5.link,
    lines = _ref5.lines,
    color = _ref5.color,
    group = _ref5.group,
    token = _ref5.token,
    providedAs = _ref5.as,
    other = _objectWithoutProperties(_ref5, _excluded);
  var as = providedAs ? providedAs : getElementType(variant, link);
  var variantName = toVariantName(variant, bold, italic, link);
  var typography = findTypography(variantName, group);
  if (typeof typography === 'undefined') {
    throw new Error("Typography variant not found for variant \"".concat(variantName, "\" (\"").concat(variant, "\") & group \"").concat(group || '', "\""));
  }
  return /*#__PURE__*/jsx(StyledTypography, _objectSpread(_objectSpread({
    as: as,
    $typography: _objectSpread(_objectSpread({}, typography), token),
    $link: link,
    $lines: lines,
    ref: ref,
    $color: color
  }, other), {}, {
    children: children
  }));
});

// Typography.displayName = 'EdsTypography'

export { Typography };
